function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.742 17.313c-5.839-1.62-14.072-1.544-18.307-.826-.511.087-.591 2.453-.137 2.536.838.34 1.195 1.19 1.195 1.19s.25.755.975 3.823c.726 3.069 2.457 3.436 2.457 3.436S7.043 28 9.485 28c2.444 0 3.905-.112 5.47-.9 1.565-.787 2.249-2.981 2.249-2.981s.788-1.89 1.33-3.674c.171-.56 2.761-.56 2.931 0 .543 1.783 1.331 3.674 1.331 3.674s.684 2.194 2.249 2.981c1.565.788 3.026.9 5.47.9 2.442 0 4.56-.528 4.56-.528s1.73-.367 2.457-3.436c.725-3.068.975-3.822.975-3.822s.357-.85 1.195-1.191c.454-.083.374-2.45-.137-2.536-4.235-.718-12.468-.794-18.307.826-.396.09-2.12.09-2.516 0z",
  fill: "#ACACAC",
  fillRule: "nonzero"
});

var SvgSunglasses = function SvgSunglasses(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSunglasses, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sunglasses.688e6bc9.svg";
export { ForwardRef as ReactComponent };